var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.963867H513V342.956H0V0.963867Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 0.958008V167.974L0 172.133V0.958008H513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.377 118.953L256.5 186.829L188.624 118.953C179.542 132.414 174.699 148.287 174.718 164.525V186.829C174.718 222.643 197.86 253.152 229.974 264.193C225.688 272.595 226.411 283.078 232.691 290.916L256.996 271.439L281.302 290.916C287.656 282.986 288.326 272.346 283.871 263.896C315.546 252.613 338.285 222.33 338.285 186.829V164.525C338.302 148.287 333.458 132.415 324.377 118.953Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 246.308C223.704 246.308 197.022 219.626 197.022 186.83V164.526C197.022 131.729 223.704 105.047 256.5 105.047C289.296 105.047 315.978 131.729 315.978 164.525V186.829C315.978 219.626 289.296 246.308 256.5 246.308Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.673 186.829V164.525C293.673 144.027 276.998 127.352 256.5 127.352C236.002 127.352 219.326 144.027 219.326 164.525V186.829L256.5 194.265L293.673 186.829Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.326 186.829C219.326 207.327 236.002 224.003 256.5 224.003C276.998 224.003 293.673 207.327 293.673 186.829H219.326Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.109 105.047C301.109 92.7284 291.123 82.7429 278.804 82.7429C273.316 82.7357 268.019 84.7601 263.935 88.426V75.3074H271.371V60.4384H263.935V53.0029H249.066V60.4384H241.631V75.3074H249.066V88.426C244.981 84.7602 239.685 82.7358 234.196 82.7429C221.877 82.7429 211.892 92.7284 211.892 105.047C211.892 111.651 214.764 117.584 219.327 121.669V134.787H293.675V121.669C298.236 117.584 301.109 111.652 301.109 105.047Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.957031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/SM.f9fa77cc9bf0ddbaa338dbdbb9115bd6.svg";
export { ForwardRef as ReactComponent };